import React from 'react';
import { PiPencilBold } from "react-icons/pi";
import { Link } from "react-router-dom"; // Link شامل کیا

import Header from '../../../header/header';
import Navvbar from '../../../header/Navvbar';
import Footer from '../../../footer';

const AddNewAccountDefaults = () => {
  return (
    <>
      <div style={{ marginBottom: "25px" }}>
        <Header />
        <Navvbar />
      </div>

      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <div className="row">
          {/* === Sidebar (Copied from CaseSetting) === */}
          <div
            className="col-md-2"
            style={{ borderRight: "1px solid #004aad" }}
          >
            <div>
              <h2 style={{ marginLeft: "10px" }}>Settings</h2>
              <div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Tabs"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Lab Details
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "13px",
                    }}
                  >
                    Store
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/usersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Users
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Permission Groups
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Account"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Accounts
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Owerviews"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Finances
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/owersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Case Settings
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* === Main Content === */}
          <div className="col-md-10">
            <h1 style={{ marginBottom: "20px" }}>Add New Account Defaults</h1>

            {/* If Section */}
            <h2 style={{ color: '#004aad', marginBottom: '10px', marginTop: '30px' }}>If</h2>
            <div style={{
              backgroundColor: '#f4f4f4',
              padding: '20px',
              borderTop: '2px solid #004aad',
              minHeight: '90px'
            }}>
              <p style={{
                margin: '0 0 20px 0',
                fontSize: '14px',
                color: '#666',
                lineHeight: '1.4'
              }}>
                You may specify "Country" and "Account type" but one is required. A location-based match is preferred over an account-type match.
              </p>

              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                maxWidth: '500px'
              }}>
                {/* Country */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <label style={{
                    fontSize: '14px', fontWeight: 'bold', color: '#333',
                    width: '120px', minWidth: '120px'
                  }}>Country</label>
                  <select style={{
                    padding: '8px 12px', border: '1px solid #ccc',
                    borderRadius: '4px', fontSize: '14px', width: '190px'
                  }}>
                    <option value="">Select Country</option>
                    <option value="US">United States</option>
                    <option value="UK">United Kingdom</option>
                    <option value="CA">Canada</option>
                    <option value="AU">Australia</option>
                  </select>
                </div>

                {/* State */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <label style={{
                    fontSize: '14px', fontWeight: 'bold', color: '#333',
                    width: '120px', minWidth: '120px'
                  }}>State</label>
                  <select style={{
                    padding: '8px 12px', border: '1px solid #ccc',
                    borderRadius: '4px', fontSize: '14px', width: '190px'
                  }}>
                    <option value="">Select State</option>
                    <option value="NY">New York</option>
                    <option value="CA">California</option>
                    <option value="TX">Texas</option>
                    <option value="FL">Florida</option>
                  </select>
                </div>

                {/* Account Type */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <label style={{
                    fontSize: '14px', fontWeight: 'bold', color: '#333',
                    width: '120px', minWidth: '120px'
                  }}>Account type</label>
                  <select style={{
                    padding: '8px 12px', border: '1px solid #ccc',
                    borderRadius: '4px', fontSize: '14px', width: '190px'
                  }}>
                    <option value="">Select Account Type</option>
                    <option value="personal">Personal</option>
                    <option value="business">Business</option>
                    <option value="premium">Premium</option>
                    <option value="enterprise">Enterprise</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Set Section */}
            <h2 style={{ color: '#004aad', marginBottom: '10px' }}>Set</h2>
            <div style={{
              backgroundColor: "#f4f4f4",
              padding: "20px",
              display: "flex",
              alignItems: "center",
              borderTop: "2px solid #004aad",
              minHeight: '90px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <label style={{
                  fontSize: '14px', fontWeight: 'bold', color: '#333',
                  width: '120px', minWidth: '120px',
                  display: 'flex', alignItems: 'center', gap: '4px'
                }}>
                  Procedure
                  <span style={{ color: '#ff0000', fontSize: '16px', fontWeight: 'bold' }}>*</span>
                </label>
                <select style={{
                  padding: '8px 12px', border: '1px solid #ccc',
                  borderRadius: '4px', fontSize: '14px', width: '190px'
                }}>
                  <option value="">Select Procedure</option>
                  <option value="group1">Procedure Group 1</option>
                  <option value="group2">Procedure Group 2</option>
                  <option value="group3">Procedure Group 3</option>
                  <option value="group4">Procedure Group 4</option>
                </select>
              </div>
            </div>

            {/* Save Button */}
            <div style={{
              display: 'flex',
              justifyContent: 'flex-start',
              padding: '20px 0',
            }}>
              <button
                style={{
                  backgroundColor: '#004aad',
                  color: 'white',
                  border: 'none',
                  padding: '12px 30px',
                  borderRadius: '6px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s ease',
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#003580'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#004aad'}
              >
                <PiPencilBold style={{ marginRight: '8px' }} /> Save
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Extra space for footer */}
     

      {/* Footer */}
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <Footer />
      </div>
    </>
  );
};

export default AddNewAccountDefaults;